function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#006AB3",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M18.172 19.346l7.884 7.884a.743.743 0 0 0 1.066.005.745.745 0 0 0 0-1.061l-7.879-7.879 1.071-1.05 7.868 7.868c.88.88.886 2.298 0 3.183a2.243 2.243 0 0 1-3.187-.006l-7.894-7.894 1.071-1.05zm7.884 7.884a.743.743 0 0 0 1.066.005.745.745 0 0 0 0-1.061l-7.879-7.879 1.071-1.05 7.868 7.868c.88.88.886 2.298 0 3.183a2.243 2.243 0 0 1-3.187-.006l-7.894-7.894 1.071-1.05 7.884 7.884z"
}), React.createElement("path", {
  d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0 1.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5z"
}));

var SvgCaseStudy = function SvgCaseStudy(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/case_study.27439bfa.svg";
export { SvgCaseStudy as ReactComponent };